<template>
  <v-row>
    <v-col
      :md="primaryMdCols"
      :offset-md="primaryMdOffset"
      :lg="primaryLgCols"
      :offset-lg="primaryLgOffset"
      cols="12"
      ref="primaryCol"
      style="padding:0">
      <transition-group
        name="slideRight"
        v-bind:css="false"
        v-on:before-enter="beforeEnter"
        v-on:enter="enter"
        v-on:leave="leave">
        <template v-for="(item, index) in primary">
          <component
            v-if="visible"
            :key="'primary-' + index"
            :is="item.type"
            :section="section"
            :col-width="primaryWidth"
            :id="item.id"
            :primary="true"
            :class="index === 0 ? 'first-item' : (index === primary.length - 1 ? 'last-item' : 'middle-item')"
            class="primary-col">
            <content-editor
              v-if="visible && editor"
              :key="'edit-prim-' + index"
              :type="item.type"
              :id="item.id"
              :is-first="index === 0"
              :is-last="index === primary.length - 1"
              :in-primary="true"
              @change="(updatedItem) => change('primary', updatedItem, index)"
              @remove="$emit('remove', { col: 'primary', index })"
              @moveUp="$emit('move', { col: 'primary', index, dir: -1 })"
              @moveDown="$emit('move', { col: 'primary', index, dir: 1 })"
              @moveRight="$emit('changeColumns', { index, col: 'primary' })"
              ></content-editor>
            </component>
        </template>
      </transition-group>
    </v-col>
    <v-col
      v-if="secondary.length > 0"
      cols="12"
      md="6"
      lg="5"
      ref="secondaryCol"
      style="padding:0">
      <transition-group
        name="slideLeft"
        v-bind:css="false"
        v-on:before-enter="beforeEnter"
        v-on:enter="enter"
        v-on:leave="leave">
        <template v-for="(item, index) in secondary">
          <component
            v-if="visible"
            :key="'secondary-' + index"
            :is="item.type"
            :section="section"
            :slide-num="slideNum"
            :col-width="secondaryWidth"
            :id="item.id"
            :index="index"
            :primary="false"
            :class="index === 0 ? 'first-item' : (index === secondary.length - 1 ? 'last-item' : 'middle-item')"
            class="secondary-col">
            <content-editor
              v-if="visible && editor"
              :key="'edit-sec-' + index"
              :id="item.id"
              :is-first="index === 0"
              :is-last="index === secondary.length - 1"
              :in-primary="false"
              @change="(updatedItem) => change('secondary', updatedItem, index)"
              @remove="$emit('remove', { col: 'secondary', index })"
              @moveUp="$emit('move', { col: 'secondary', index, dir: -1 })"
              @moveDown="$emit('move', { col: 'secondary', index, dir: 1 })"
              @moveLeft="$emit('changeColumns', { index, col: 'secondary' })"
              ></content-editor>
          </component>
        </template>
      </transition-group>
    </v-col>
  </v-row>
</template>
<style>
.primary-col, .secondary-col {
  margin: 12px;
}
</style>
<script>
import { ref, computed, watch } from '@vue/composition-api'
import { beforeEnter, enter, leave, activeTransitions, transitionsDone } from '@/components/transitions'

export default {
  components: {
    ContentEditor: () => import('@/components/admin/contentEditor'),
    TextCard: () => import('@/components/slides/textCard'),
    ImageCard: () => import('@/components/slides/imageCard'),
    VideoCard: () => import('@/components/slides/videoCard'),
    QuizCard: () => import('@/components/slides/quizCard'),
    Carousel: () => import('@/components/slides/carousel'),
    Agreement: () => import('@/components/slides/agreement'),
    Popups: () => import('@/components/slides/popups'),
    Timeline: () => import('@/components/slides/timeline')
  },
  props: {
    section: {
      type: String,
      required: true
    },
    slideNum: {
      type: Number,
      required: true
    },
    primary: {
      type: Array,
      required: true
    },
    secondary: {
      type: Array,
      default: () => {
        return []
      }
    },
    visible: {
      type: Boolean,
      default: false
    },
    editor: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { root, emit }) {
    const primaryCol = ref(null)
    const secondaryCol = ref(null)

    const primaryMdCols = computed(() => props.secondary.length > 0 ? 6 : 10)
    const primaryMdOffset = computed(() => props.secondary.length > 0 ? 0 : 1)
    const primaryLgCols = computed(() => props.secondary.length > 0 ? 5 : 8)
    const primaryLgOffset = computed(() => props.secondary.length > 0 ? 1 : 2)

    const primaryWidth = computed(() => primaryCol.value ? primaryCol.value.offsetWidth - 25 : 160)
    const secondaryWidth = computed(() => secondaryCol.value ? secondaryCol.value.offsetWidth - 25 : 160)

    watch(transitionsDone, () => {
      if (transitionsDone.value) {
        emit('out')
      }
    })

    function change (col, item, index) {
      emit('change', { col, index, item })
    }

    return {
      primaryCol,
      secondaryCol,
      primaryMdCols,
      primaryMdOffset,
      primaryLgCols,
      primaryLgOffset,
      primaryWidth,
      secondaryWidth,
      beforeEnter,
      enter,
      leave,
      activeTransitions,
      transitionsDone,
      change
    }
  }
}
</script>
